/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchRemantAlertsChartData } from "../../../api/alertsApi";


const sensor_filter = `sensor.excludeFromUi = 0`;

function useGetRemnantAlertsCount() {

    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const filter = sessionStorage.getItem('alertApplyfilter');
    const finalFilter = filter ? `${filter} AND ${sensor_filter}` : sensor_filter;

    useEffect(() => {
        setLoading(true);
        fetchRemantAlertsChartData(finalFilter).then(data => {
            var result = {
                    eventCode: [],
                    count: []
                }
            if (data.length > 0){
                data.map(item => {
                    result["eventCode"].push(item.eventCode);
                    result["count"].push(item.count);
                });
            }
            setData(result);
        }).catch(error => {
            console.error(error);
            toast.error(`Cannot fetch Remnant Alerts Count`);
            setError(error);
        }).finally(() => {
            setLoading(false);
        });
    }, [
        filter
    ]);

    return { data, loading, error };
}

export default useGetRemnantAlertsCount;